// extracted by mini-css-extract-plugin
export default {"errWrap":"index-module__errWrap__VUaeA"};